module.exports = __webpack_public_path__ + "static/media/landing-bottom-person-ex.ac58afa7.png";